import React from "react";
import style from "./style.module.scss";
import Row from "./Row";
import SkeletonRow from "../../../../../components/skeleton-loader/table/row";
import { formatCurrency } from "../../../../../../components/helper/helper";

const ResidualCalculationsTable = ({
  data = [],
  residualAmount,
  requiresSingleMonth = false,
  loading,
}) => {
  const tableData = Array.isArray(data) ? data : [];

  const splitTotal = tableData.reduce(
    (acc, row) => acc + (row.split_amount || 0),
    0,
  );

  const renderRows = () => {
    const rows = [];
    let lastCategory = null;

    tableData.forEach((row, index) => {
      if (row.category && row.category !== lastCategory) {
        rows.push(
          <tr key={`cat-${index}`} className={style.category_row}>
            <td colSpan="9" className={style.category_cell}>
              {row.category}
            </td>
          </tr>,
        );
        lastCategory = row.category;
      }
      rows.push(<Row data={row} key={index} />);
    });

    return rows;
  };

  return (
    <div className={style.table_container}>
      <table className={style.table}>
        <thead>
          <tr className={style.header_row}>
            <th className={style.header_cell}>Income Field Name</th>
            <th className={style.header_cell}>Income Amount</th>
            <th className={style.header_cell}>Expense Amount</th>
            <th className={style.header_cell}>Times Rate</th>
            <th className={style.header_cell}>Calculation Amount</th>
            <th className={style.header_cell}>Agent Expense</th>
            <th className={style.header_cell}>Line Amount</th>
            <th className={style.header_cell}>Split Rate</th>
            <th className={style.header_cell}>Split Amount</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            Array.from({ length: 10 }).map((_, index) => (
              <SkeletonRow key={`rc-skeleton-${index}`} columnLength={9} />
            ))
          ) : requiresSingleMonth ? (
            <tr>
              <td colSpan="9" className={style.no_data}>
                Select a single month to view residual calculation.
              </td>
            </tr>
          ) : tableData.length === 0 ? (
            <tr>
              <td colSpan="9" className={style.no_data}>
                No data to display
              </td>
            </tr>
          ) : (
            <>
              {renderRows()}
              <tr className={style.footer_row}>
                <td colSpan="7" className={style.footer_cell} />
                <td className={style.footer_cell}>Split Amount:</td>
                <td className={style.footer_cell}>
                  $ {formatCurrency(splitTotal)}
                </td>
              </tr>
              <tr className={style.footer_row}>
                <td colSpan="7" className={style.footer_cell} />
                <td className={style.footer_cell}>Residual Amount:</td>
                <td className={style.footer_cell}>
                  $ {formatCurrency(residualAmount ?? 0)}
                </td>
              </tr>
            </>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ResidualCalculationsTable;
